import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router";
import { getOneApplicationDetail } from "../../auth/services/privateapicalling";
import useCommonServices from "../../../hooks/useCommonServices";
import { ShimmerSectionHeader } from "react-shimmer-effects";

interface ApplicationDetails {
  departmentId: string;
  applicantName: string;
  regEmailId: string;
  mobileNo: string;
  applicationId: string;
  status: string;
  paymentStatus: string;
  paymentOrderId: string;
  trxDate: string; // Added trxDate property
  amount: number;
  paymentMode: string;
  orderID: string;
  TotalTax: string;
  applicationDetails: {
    applicantName: string;

    [key: string]: any; // Allow additional properties if needed
  };
  department: {
    apmcName: string;
    [key: string]: any; // Allow additional properties if needed
  };
}
const PaymentSuccess: React.FC =
  (/* { status, transactionId, amount, dateTime } */) => {
    const formatDateTime = (dateTime: string): string => {
      const date = new Date(dateTime);
      const options: Intl.DateTimeFormatOptions = {
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        hour12: true,
      };
      return date.toLocaleString("en-US", options);
    };

    const [application, setApplication] = useState<ApplicationDetails | null>(
      null
    );
    const [isTransactionStatusLoading , setIsTransactionStatusLoading] = useState(true)
    const token = useSelector((state: any) => state.auth.token);
    const { getOrderDetail } = useCommonServices();

    const navigate = useNavigate();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const { applicationId } = useParams<{ applicationId: string }>();

    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);
    const orderId = queryParams.get("orderID");
    //.log("orderid", applicationId, orderId);

    const getTransactionDetails = async (
      orderId: string,
      applicationId: string,
      token: string
    ) => {
      try {
        const response = await getOrderDetail(applicationId, orderId, token);
        setIsTransactionStatusLoading(false)
        //.log("response", response);
        setApplication(response.data);
      } catch (error) {
        setError("Failed to load transaction details");
      } finally {
        setLoading(false);
      }
    };

    useEffect(() => {
      setIsTransactionStatusLoading(true);

      if (!applicationId) {
        //.error("Application ID is missing in the URL parameters.");
      setIsTransactionStatusLoading(false);

        setError("Missing application ID in the URL");
        setLoading(false);
        // alert("Missing application ID in the URL");
        return;
      }

      if (!orderId) {
        //.error("Order ID is missing in the query parameters.");
      setIsTransactionStatusLoading(false);

        setError("Missing order ID in the URL");
        setLoading(false);
        // alert("Missing order ID in the URL");
        return;
      }

      if (orderId && applicationId) {
        //.log("orderid inside", orderId, applicationId, token);

        getTransactionDetails(orderId, applicationId, token);
      }

      // fetchApplicationDetails(applicationId);
    }, [applicationId, orderId]);

    const getPaymentModeLabel = (value: string): string => {
      const paymentModes: { [key: string]: string } = {
        NB: "Net Banking",
        CC: "Credit Card",
        DC: "Debit Card",
        WALLET: "Wallet",
        PC: "Prepaid Cards",
        CASH: "Cash",
        NEFT: "NEFT",
        PAYPAL: "PayPal",
        UPI: "UPI",
      };

      return paymentModes[value] || "Unknown";
    };
    const language = useSelector((state: any) => state.auth.language);
    const transactionId = "sdfg56";
    const amount = "1000";
    const appId = applicationId ? applicationId : "";
    let dateTime = application?.trxDate
      ? formatDateTime(application?.trxDate)
      : "";
    //.log("dateTime", dateTime);
    let isSuccess = application?.status=== "SUCCESS" ? true : false
    const pdfFilePath = "/static/payment_receipt.pdf"; // Static PDF path
    const paymentMode = application?.paymentMode
      ? getPaymentModeLabel(application?.paymentMode)
      : "";

    const convertAmountToWords = (amount: number): string => {
      const units = [
        "",
        "One",
        "Two",
        "Three",
        "Four",
        "Five",
        "Six",
        "Seven",
        "Eight",
        "Nine",
      ];
      const teens = [
        "Eleven",
        "Twelve",
        "Thirteen",
        "Fourteen",
        "Fifteen",
        "Sixteen",
        "Seventeen",
        "Eighteen",
        "Nineteen",
      ];
      const tens = [
        "",
        "Ten",
        "Twenty",
        "Thirty",
        "Forty",
        "Fifty",
        "Sixty",
        "Seventy",
        "Eighty",
        "Ninety",
      ];
      const thousands = ["", "Thousand", "Million", "Billion"];

      if (amount === 0) return "Zero";

      const getWords = (num: number): string => {
        let word = "";

        if (num > 99) {
          word += units[Math.floor(num / 100)] + " Hundred ";
          num %= 100;
        }

        if (num > 10 && num < 20) {
          word += teens[num - 11] + " ";
        } else {
          word += tens[Math.floor(num / 10)] + " ";
          num %= 10;
          word += units[num] + " ";
        }

        return word.trim();
      };

      let word = "";
      let i = 0;

      while (amount > 0) {
        const chunk = amount % 1000;
        if (chunk > 0) {
          word = getWords(chunk) + " " + thousands[i] + " " + word;
        }
        amount = Math.floor(amount / 1000);
        i++;
      }

      return word.trim() + " Rupees Only";
    };

    const amountInWords = application?.amount
      ? convertAmountToWords(application?.amount)
      : "";
    const handleOK = () => {
      navigate("/my-applications");
    };
    const calculateTotalAmount = (totalTax: string | null, amount: number | null): number => {
      if (!totalTax || !amount) {
        //.error("Invalid input: totalTax or amount is null");
        return 0;
      }

      const taxParts = totalTax.split("^");
      if (taxParts.length !== 2) {
        //.error("Invalid totalTax format");
        return 0;
      }

      const tax1 = Number(taxParts[0]);
      const tax2 = Number(taxParts[1]);

      if (isNaN(tax1) || isNaN(tax2)) {
        //.error("Invalid tax values in totalTax");
        return 0;
      }

      return tax1 + tax2 + (amount || 0);
    };

    

    const totalAmnt = calculateTotalAmount(application?.TotalTax, application?.amount);
    const generateAndDownloadReceipt = () => {
      if (!application) {
        //.error("Application data is missing.");
        return;
      }

      const receiptHtml = `<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Payment Invoice</title>
    <style>
        body {
            font-family: 'Arial', sans-serif;
            margin: 0;
            padding: 0;
            background: #f4f7fa;
            color: #333;
        }

        .invoice-container {
            width: 80%;
            max-width: 800px;
            margin: 50px auto;
            padding: 30px;
            background: #fff;
            box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
            border-radius: 8px;
        }

        .invoice-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 30px;
            border-bottom: 2px solid #eee;
            padding-bottom: 15px;
        }

        .invoice-header .company-info {
            font-size: 18px;
        }

        .invoice-header .company-info h2 {
            margin: 0;
            color: #2d3e50;
        }

        .invoice-header .company-info p {
            margin: 5px 0;
            font-size: 14px;
            color: #6c757d;
        }

        .invoice-header .invoice-info {
            text-align: right;
        }

        .invoice-header .invoice-info p {
            margin: 5px 0;
            font-size: 14px;
            color: #6c757d;
        }

        .invoice-body {
            margin: 30px 0;
        }

        .invoice-body .item-row {
            display: flex;
            justify-content: space-between;
            padding: 10px 0;
            border-bottom: 1px solid #eee;
        }

        .invoice-body .item-row:last-child {
            border-bottom: none;
        }

        .invoice-body .item-row .item {
            flex: 1;
            font-size: 14px;
        }

        .invoice-body .item-row .amount {
            text-align: right;
            font-size: 14px;
        }

        .total-row {
            display: flex;
            justify-content: flex-end;
            padding: 10px 0;
            border-top: 2px solid #eee;
            margin-top: 20px;
        }

        .total-row .total-label {
            font-weight: bold;
            margin-right: 10px;
        }

        .total-row .total-amount {
            font-size: 18px;
            font-weight: bold;
            color: #28a745;
        }

        .footer {
            text-align: center;
            margin-top: 30px;
            font-size: 12px;
            color: #6c757d;
        }

        .footer p {
            margin: 5px 0;
        }
    </style>
</head>
<body>

    <div class="invoice-container">
        <!-- Invoice Header -->
        <div class="invoice-header">
            <div class="company-info">
                <h2>${application?.department?.apmcName}</h2>
                <p>${application?.department?.Address}</p>
                <p>${application?.department?.Taluka} , ${application?.department?.District} , ${application?.department?.Pin_Code} </p>
                <p>Email: ${application.applicationDetails?.regEmailId ? application.applicationDetails?.regEmailId :""}</p>
                <p>Phone: ${application.applicationDetails?.mobileNo ?application.applicationDetails?.mobileNo :""}</p>
            </div>

            <div class="invoice-info">
                <p><strong>Invoice #:</strong> ${application?.orderID}</p>
                <p><strong>Date:</strong> ${dateTime}</p>
            </div>
        </div>

        <!-- Invoice Body -->
        <div class="invoice-body">
            <div
            <div class="item-row">
                <div class="item">Mode of Transaction</div>
                <div class="amount">${paymentMode}</div>
            </div>
            <div class="item-row">
                <div class="item">Amount</div>
                <div class="amount">₹ ${application?.amount}</div>
            </div>
            <div class="item-row">
                <div class="item">Processing + Tax </div>
                <div class="amount">₹ ${application?.TotalTax ? application?.TotalTax.split('^')[0] : 0 } + ₹ ${application?.TotalTax ? application?.TotalTax.split('^')[1]:0}</div>
            </div>
            <div class="item-row">
                <div class="item">Amount in Words</div>
                <div class="amount">${amountInWords}</div>
            </div>
            <div class="item-row">
                <div class="item">Recipient Name</div>
                <div class="amount">${application?.applicationDetails?.applicantName}</div>
            </div>
        </div>

        <!-- Total -->
        <div class="total-row">
            <div class="total-label">Total Amount</div>
            <div class="total-amount">₹ ${totalAmnt ? totalAmnt :""}</div>
        </div>

        <!-- Footer -->
        <div class="footer">
            <p>Thank you for your business!</p>
            <p>If you have any questions, please contact us at helpdesk@thesaicomputers.com</p>
        </div>
    </div>

</body>
</html>
    `;

      const blob = new Blob([receiptHtml], { type: "text/html" });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `Payment_Receipt_${application.applicationId}.html`;
      link.click();
      URL.revokeObjectURL(url);
    };


    return (
      <div className="cardhead page-wrapper">
        <div className="container-fluid content">
          <div className="page-header"></div>
         { isTransactionStatusLoading ? 
         <div>
        <ShimmerSectionHeader />
        <ShimmerSectionHeader  />
      </div>
         :
          <div className="card vh-80">
            <div className="d-flex flex-column align-items-center justify-content-center text-center">
              <div
                className={`  p-4 border-${isSuccess ? "success" : "danger"}`}
              >
                {/* Success or Failure Icon */}
                <div
                  className={`mb-3 text-${isSuccess ? "success" : "danger"}`}
                >
                  <i
                    className={`fa-solid ${
                      isSuccess ? "fa-circle-check" : "fa-circle-xmark"
                    } fa-6x`}
                  ></i>
                </div>

                {/* Success or Failure Message */}
                <h1 className={`text-${isSuccess ? "dark" : "danger"} mb-3`}>
                  {isSuccess
                    ? `₹${application?.amount ? application?.amount : ""}`
                    : language.transaction_declined}
                </h1>

                <div
                  className={`text-${isSuccess ? "secondary" : "danger"} fs-25`}
                >
                  {isSuccess ? (
                    <span>
                      {language.payment_status} <strong>{appId}</strong>
                      {language.payment_successfull}
                    </span>
                  ) : (
                    language.payment_s
                  )}
                   <div className="d-flex align-items-center gap-2">
  <p className="mb-0">
    {language.order_id}: <b>{application?.orderID}</b>
  </p>

  {/* Separator Line */}
  <span className="text-muted">|</span>

  <p className="mb-0">{dateTime}</p>

  {/* <span className="text-muted">|</span> */} {/* Uncomment if needed */}
  
  {/* <p className="mb-0"><strong>{language.amount}:</strong> ₹{amount}</p> */} {/* Uncomment if needed */}
</div>
                </div>
                {/* Download Receipt Button (Only for Success) */}
                {isSuccess ? (
                  <div className="d-flex align-items-center justify-content-center gap-3 mt-3">
                    {/* Download Receipt Button */}
                    {/* <a
      href={pdfFilePath}
      download={`Payment_Receipt_${transactionId}.pdf`}
      className="btn btn-info"
    >
      <i className="bi bi-download"></i> {language.download}
    </a> */}
                    
                      {/* Retry Payment Button */}
                      <button
                        className="btn btn-info"
                        onClick={generateAndDownloadReceipt}
                      >
                        {language.download}
                      </button>
                   

                    {/* OK Button */}
                    <button className="btn btn-success" onClick={handleOK}>
                      {language.ok}
                    </button>
                  </div>
                ) : (
                  <div className="d-flex justify-content-center gap-3 mt-3">
                    {/* Retry Payment Button */}
                    <button className="btn btn-danger text-white" onClick={handleOK}>
                      {language.retry_payment}
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>}
        </div>
      </div>
    );
  };

export default PaymentSuccess;
